import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  DirectionsCar as CarIcon,
  BookOnline as ReservaIcon,
  Build as BuildIcon,
  PointOfSale as SaleIcon,
  Assessment as ReportIcon,
  Description as DocIcon,
  FactCheck as AvaliacaoIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import {
  canAccessAvaliacoes,
  canAccessConfiguracoes,
  canAccessRelatorios,
  canAccessReservas,
  canAccessVendas,
} from '../../utils/permissions';

const drawerWidth = 240;

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
  { text: 'Clientes', icon: <PeopleIcon />, path: '/clientes' },
  { text: 'Veículos', icon: <CarIcon />, path: '/veiculos' },
  { text: 'Prospecções', icon: <ReservaIcon />, path: '/reservas' },
  { text: 'Manutenções', icon: <BuildIcon />, path: '/manutencoes' },
  { text: 'Vendas', icon: <SaleIcon />, path: '/vendas' },
  { text: 'Relatórios', icon: <ReportIcon />, path: '/relatorios' },
  { text: 'Documentos', icon: <DocIcon />, path: '/documentos' },
  { text: 'Avaliações', icon: <AvaliacaoIcon />, path: '/avaliacoes' },
  { text: 'Configurações', icon: <SettingsIcon />, path: '/configuracoes' },
];

export default function Layout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuPermitido = menuItems.filter((item) => {
    if (item.path === '/configuracoes') return canAccessConfiguracoes(usuario);
    if (item.path === '/relatorios') return canAccessRelatorios(usuario);
    if (item.path === '/vendas') return canAccessVendas(usuario);
    if (item.path === '/reservas') return canAccessReservas(usuario);
    if (item.path === '/avaliacoes') return canAccessAvaliacoes(usuario);
    return true;
  });

  const drawer = (
    <div>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          BaseComm
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        {menuPermitido.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton onClick={() => navigate(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Sair" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: '#111111',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            BaseComm - Sistema de Gestão
          </Typography>
          <Typography variant="body1">
            {usuario?.nome} ({usuario?.nivel_acesso})
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: '#0f0f0f',
              borderRight: '1px solid rgba(255,255,255,0.08)',
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: '#0f0f0f',
              borderRight: '1px solid rgba(255,255,255,0.08)',
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: 8,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}


